import React from "react";
import { IForm } from "../base/models/forms";
import { getCollection, addUpdateDocumentInCollection, getForm } from "../base/firestore-utils";
import NotificationsService from "../services/notifications";
import { IFormSubmission } from "../base/models/formSubmission";
import { IUserAuthPayload } from "../base/models/user";
import { IFirebaseContext } from "../base/firebase";

export default class DataUtils {
	private static _context: IFirebaseContext;
	static get context(): IFirebaseContext {
		return DataUtils._context;
	}

	public static async loadTenant(context: IFirebaseContext) {
		if (!context || !context.tenant) {
			throw new Error("Tenant not initialized, provide tenant in context.");
		}
		console.log("loadTenant:", context.tenant);
		DataUtils._context = context;
		context.clientFirebase.init(context.tenant, true); // initalize in case hasn't been initialized
	}

	public static async getForm(formId: string, firebase?): Promise<IForm> {
		if (!formId) throw Error("getForm(): No formId");
		return getForm(formId, DataUtils.context.clientFirebase?.getFirebase())
			.then((form: IForm) => {
				if (!form || !form.name) {
					console.log("No form by id:", formId);
					NotificationsService.error("No form with id: " + formId);
					return Promise.reject(null);
				}
				return form;
			})
			.catch((err) => {
				console.log("No form by id:", formId, err);
				NotificationsService.error("No form with id: " + formId);
				return Promise.reject(null);
			});
	}

	public static async getForms(admin?: boolean): Promise<IForm[]> {
		const isAdminUser: boolean = admin !== undefined ? admin : DataUtils.context.userPayload?.role === "admin";
		return getCollection<IForm>(
			DataUtils.context.clientFirebase,
			"forms",
			"order",
			isAdminUser ? undefined : (query) => query.where("active", "==", true)
		);
	}

	public static async addFormSubmission(
		formId: string,
		formValues,
		formConfig: IForm,
		userPayload1?: Partial<IUserAuthPayload>
	): Promise<any> {
		const userPayload = userPayload1 || DataUtils.context.userPayload;
		// if (!userPayload) {
		//  throw Error("No logged in user");
		// }
		const email: string = formValues.email || formValues["user-email"] || "";
		const uid: string = userPayload?.uid || email || "";
		const userDetails = {
			email: userPayload?.email || email,
			name: userPayload?.displayName || formValues.name || "",
		};
		const formSubmission: IFormSubmission = {
			formId,
			...formValues,
			uid,
			formSubmissionUserDetails: userDetails,
		};
		const id: string = `${uid == "site-contact" && email ? email : uid}-${formId}-${Date.now()}`;
		return addUpdateDocumentInCollection(
			DataUtils.context.clientFirebase,
			"form_submissions",
			formSubmission,
			id
		).then(() => {
			return { ...formSubmission, id };
		});
	}
}
